import { createAssetManagementClient } from '@/shared/api/client'
import { validateResponseIsOk } from '@/shared/api/validation'

const client = createAssetManagementClient()

export async function deleteInvoiceCharge(invoiceId: number, invoiceChargeId: number){
    await client.sendDelete(`billing/invoices/${invoiceId}/charges/${invoiceChargeId}`)
}